__turbopack_context__.v({
  "arrow": "OfferDetail-module__69CJ1W__arrow",
  "block": "OfferDetail-module__69CJ1W__block",
  "blockLabel": "OfferDetail-module__69CJ1W__blockLabel",
  "blockPromise": "OfferDetail-module__69CJ1W__blockPromise",
  "blockText": "OfferDetail-module__69CJ1W__blockText",
  "blockTextPromise": "OfferDetail-module__69CJ1W__blockTextPromise",
  "chip": "OfferDetail-module__69CJ1W__chip",
  "chipPrice": "OfferDetail-module__69CJ1W__chipPrice",
  "chipPriceText": "OfferDetail-module__69CJ1W__chipPriceText",
  "chipText": "OfferDetail-module__69CJ1W__chipText",
  "container": "OfferDetail-module__69CJ1W__container",
  "meta": "OfferDetail-module__69CJ1W__meta",
  "tabPanel": "OfferDetail-module__69CJ1W__tabPanel",
  "transform": "OfferDetail-module__69CJ1W__transform",
});
